import { t } from 'i18next';
import { useEnv } from '../../../context/env-context';
import type { I18nPrefix } from '../../../i18n/prefix';
import { buildCssSnippet } from '../utils/snippets';
import { CodeSnippet } from './code-snippet';
import { WidgetSection } from './widget-section';

const PAGE = 'features:storefront_widgets.pages.storefront_widgets_page.css' satisfies I18nPrefix;

export function CssTab() {
  const env = useEnv();

  return (
    <WidgetSection
      title={t(`${PAGE}.title`)}
      subtitle={t(`${PAGE}.description`)}
      learnMoreUrl="https://docs.sparklayer.io/customising-design"
    >
      <CodeSnippet code={buildCssSnippet(env)} />
    </WidgetSection>
  );
}
